import axios from 'axios'

const origin = process.env.VUE_APP_API_ORIGIN
const responseData = response => response.data

export default {
  get () {
    return axios.get(origin + '/personal-settings').then(responseData)
  },
  updateProfile (payload) {
    return axios.post(origin + '/personal-settings/profile', payload).then(responseData)
  },
  updatePassword (payload) {
    return axios.post(origin + '/personal-settings/password', payload).then(responseData)
  }
}
